import React from 'react'
import {useTranslation} from 'react-i18next'
import IDropdownVal from 'models/dropdown'
import {IFormField} from 'models/Common'

type Props = {
 className?: string
 location?: IFormField
}

const KTUserLocation: React.FC<Props> = (props) => {
 const {t} = useTranslation()
 const subDistricts = props.location?.subdistricts
  ?.map((val: IDropdownVal) => val.name)
  .join(', ')
 const districts = props.location?.districts
  ?.map((val: IDropdownVal) => val.name)
  .join(', ')
 const states = props.location?.states
  ?.map((val: IDropdownVal) => val.name)
  .join(', ')
 return (
  <div>
   {subDistricts && (
    <div>
     {t('userDetails.subDistrict')}: {subDistricts}
    </div>
   )}
   {districts && (
    <div>
     {t('userDetails.district')}: {districts}
    </div>
   )}
   {states && (
    <div>
     {t('userDetails.state')}: {states}
    </div>
   )}
  </div>
 )
}

export {KTUserLocation}
